import React from "react";
import FeatureCard from "../FeatureCard";

export default () => (
  <FeatureCard to="/partnership/branding" image="/static/img/Card-SkywardBranding.png" imageAlt="Partners shaking hands" description="Utilize Skyward Branding">
    Learn how our partners can proudly display Skyward branding alongside their own marketing materials!
  </FeatureCard>
);
